import { Tick } from '@/icons'

export function TickIcon() {
  return <Tick size={12} color="$scienceBlue" marginTop={2} marginRight={10} />
}
